/**
 * Represents the type of an Auth0 authentication log entry.
 */
export enum AuthLogTypeModel {
	/**
	 * A login attempt failed.
	 */
	LoginFailure = 1,
	/**
	 * A multi-factor authentication step failed.
	 */
	MfaFailure = 2,
	/**
	 * A password was changed.
	 */
	PasswordChange = 3,
	/**
	 * A session operation failed.
	 */
	SessionFailure = 4,
	/**
	 * An account was locked out.
	 */
	AccountLockout = 5,
	/**
	 * A single sign-on operation failed.
	 */
	SsoFailure = 6,
	/**
	 * A persistent session operation failed.
	 */
	PersistentSessionFailure = 7,
	/**
	 * A management operation was performed.
	 */
	ManagementOperation = 8,
	/**
	 * A rate limit was reached.
	 */
	RateLimit = 9,
	/**
	 * Bot activity was detected.
	 */
	BotDetection = 10
}
